import Checkbox from './Checkbox'
import './Checkbox.sass'

export default Checkbox
